export default __webpack_public_path__ + "static/media/opensource.d8c588f6.svg";